import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    width: 70,
  },
  {
    title: "Descrizione",
    key: "description",
    dataIndex: "description",
    ellipsis: true,
    width: 100,
  },
  {
    title: "Revisione ogni",
    key: "inspectionMonths",
    dataIndex: "inspectionMonths",
    ellipsis: true,
    width: 100,
    render: (x) => x != null ? `${x} mesi` : ""
  },
];

export default function () {

  return (
    <SimpleTablePage
      resource="setupType"
      columns={columns}
    />
  );
}
